import '@fontsource-variable/onest/index.css';
import '@fontsource-variable/unbounded/index.css';
import '@astryxdesign/core/reset.css';
import '@astryxdesign/core/astryx.css';
import './app/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { InternationalizationProvider } from '@astryxdesign/core/i18n';
import ru from '@astryxdesign/core/locales/ru-RU.json';
import { router } from './app/router';
import { ApiError } from './lib/api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (n, e) => n < 2 && !(e instanceof ApiError && !['network'].includes(e.code)),
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <InternationalizationProvider locale="ru-RU" messages={{ 'ru-RU': ru }}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </InternationalizationProvider>
  </StrictMode>,
);
